import { createMockComponent } from '~/tests/helpers/createMockComponent';

const Form = createMockComponent('Form', 'form');

export default Form;
